import { TRegistrationPage } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { getPath } from '@/utils/urlUtils'

import { Lock3 } from '@/shared/icons/Lock3'

import i18next from './../../i18n'

export const registrationPage: TRegistrationPage = {
  title: i18next.t('registrationPage.title'),
  tabTitle: i18next.t('registrationPage.tabTitle'),
  nextUrl: getPath(PageName.warmUpScreen),

  inputPlaceholder: i18next.t('registrationPage.inputPlaceholder'),
  description: i18next.t('registrationPage.description'),
  descriptionImageNode: <Lock3 width={16} height={21} />,
  buttonName: i18next.t('registrationPage.buttonName'),
}
